import OtherList from '@/components/ProductCommon/OtherList';
import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import EFVideo from '@/components/UI/EFVideo';
import Image from '@/components/UI/Image';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { getDetaileMoreProducts } from '@/utils';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/smarthomepanel/h5/');

export default function SmartHomePanel() {
    const { useRef, useState, useEffect, gloproductlist, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('smarthomepanel');
    const [floatVideo, setFloatVideo] = useState(false);
    const listContainerRef = useRef();
    const [activeKey, setActiveKey] = useState({ key: 0, flag: 0 });
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'jp', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const imgLocalPhone = locale === 'sa' ? 'sa-ar' : getImageLocal(locale, ['jp', 'de', 'fr', 'cn', 'es', 'it', 'za', 'ru', 'cis']);
    const imgLocalPhone2 = getImageLocal(locale, ['jp', 'de', 'fr', 'cn', 'es']);

    // 图片后缀
    const suffix = ['es'].includes(locale) ? 'jpg' : 'png';

    const otherProduct = getDetaileMoreProducts(
        gloproductlist,
        locale === 'br' ? ['product_ps_delta_delta_pro_plus'] : ['product_ps_delta_delta_pro', 'product_ps_delta_pro_extra_battery'],
        '',
        '',
        locale === 'br' ? 'https://br.ecoflow.com/collections/portable-power-stations' : `https://${locale}.ecoflow.com/collections/smart-devices`,
    );
    const swiperData: Array<object> = [
        {
            img: [`phone_${imgLocalPhone2}.webp`, `phone_${imgLocalPhone2}.${suffix}`],
            text: t('smart_home_panel.ten_text'),
        },
        {
            img: [`phone_01_${imgLocalPhone2}.webp`, `phone_01_${imgLocalPhone2}.${suffix}`],
            text: t('smart_home_panel.ten_text1'),
        },
    ];
    // 多添加首尾各一项，以实现轮播无缝连接
    const items = [swiperData[swiperData.length - 1], ...swiperData, swiperData[0]];

    let startX = 0,
        endX = 0;
    const touchStart = (e: any) => {
        startX = e.changedTouches[0].clientX || 0;
    };

    const touchEnd = (e: any) => {
        endX = e.changedTouches[0].clientX || 0;
        if (endX > startX) {
            if (activeKey.key <= 0) {
                setActiveKey({ key: swiperData.length - 1, flag: -1 });
            } else {
                setActiveKey({ key: activeKey.key - 1, flag: 0 });
            }
        }
        if (endX < startX) {
            if (activeKey.key >= swiperData.length - 1) {
                setActiveKey({ key: 0, flag: 1 });
            } else {
                setActiveKey({ key: activeKey.key + 1, flag: 0 });
            }
        }
    };

    // js动效
    const animate = (activeKey: any) => {
        const originX = parseFloat(listContainerRef?.current?.style?.transform.split('(')[1]) || -3.25;
        const add = activeKey.flag === -1 ? 0 : activeKey.flag === 1 ? -3.25 * (items.length - 1) : -3.25 * (activeKey.key + 1);
        listContainerRef?.current?.animate([{ transform: `translateX(${originX}rem)` }, { transform: `translateX(${add}rem)` }], {
            duration: originX === add ? 0 : 300,
            delay: 0,
            fill: 'forwards',
            easing: 'linear',
            iterations: 1,
        });
        switch (activeKey.flag) {
            case -1:
                listContainerRef.current.style.transform = `translateX(${-3.25 * swiperData.length}rem)`;
                break;
            case 1:
                listContainerRef.current.style.transform = `translateX(-3.25rem)`;
                break;
            case 0:
                listContainerRef.current.style.transform = `translateX(${add}rem)`;
                break;
            default:
                console.error("customer swiper's activeKey object goes wrong!");
        }
    };

    useEffect(() => {
        animate(activeKey);
    }, [activeKey]);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'Smart Home Panel - Power your entire home.',
            position,
        });
        setFloatVideo(true);
    };

    return (
        <div className={`${css.smartHomePanel} smartHomePanel`}>
            <div className="prd-video">
                <div className="content">
                    <h4 className="title">{t('smart_home_panel.title')}</h4>
                    <h3 className="subtitle font-family-semibold">{t('smart_home_panel.subtitle')}</h3>
                    <div className="videoButton" onClick={() => playerVideo(t('smart_home_panel.title'))}>
                        <span className="btnText font-family-medium">{t('smart_home_panel.watch_video')}</span>
                        <span className="img-icon">
                            <Image src="/icons/video_play_white.svg" layout="fill" alt={t('Watch video')} />
                        </span>
                    </div>
                </div>
                <div className="img-wrapper">
                    <EFPic name={['product_1.webp', 'product_1.png']} alt={t('Smart Home Panel')} />
                </div>
            </div>
            <div className="textContainer">{t('smart_home_panel.third_title')}</div>
            <div className="ytdd">
                <div className="section section1">
                    <h3 className="tit">{t('smart_home_panel.ytdd_sec1_tit')}</h3>
                    <p className="subtit">{t('smart_home_panel.ytdd_sec1_subtit')}</p>
                    <div className="bg-img">
                        <EFPic name={['section1_h5.webp', 'section1_h5.png']} className="fullImgs" alt={t('Smart Home Panel')} />
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-sec1">
                        <h3 className="tit">{t('smart_home_panel.ytdd_sec2-sec1_tit')}</h3>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec1_h5.webp', 'sec2-sec1_h5.png']} className="fullImgs" alt={t('Smart Home Panel')} />
                        </div>
                    </div>
                    <div className="section sec2-sec2">
                        <h3 className="tit">{t('smart_home_panel.ytdd_sec2-sec2_tit')}</h3>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec2_h5.webp', 'sec2-sec2_h5.png']} className="fullImgs" alt={t('Smart Home Panel')} />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">{t('smart_home_panel.ytdd_sec3_tit')}</h3>
                    <div className="bg-img">
                        <EFPic name={['section3_h5.webp', 'section3_h5.png']} className="fullImgs" alt={t('Smart Home Panel')} />
                    </div>
                </div>
                <div className="section section4">
                    <h3 className="tit">{t('smart_home_panel.ytdd_sec4_tit')}</h3>
                    <div className="bg-img">
                        <EFPic name={['section4_h5.webp', 'section4_h5.png']} className="fullImgs" alt={t('Smart Home Panel')} />
                    </div>
                </div>
                <div className="section section5">
                    <h3 className="tit">{t('smart_home_panel.ytdd_sec5_tit')}</h3>
                    <p className="subtit">{t('smart_home_panel.ytdd_sec5_subtit')}</p>
                    <div className="bg-img">
                        <EFPic
                            name={locale === 'jp' ? ['section5_h5_jp.webp', 'section5_h5_jp.jpg'] : ['section5_h5_en.webp', 'section5_h5_en.png']}
                            className="fullImgs"
                            alt={t('Smart Home Panel')}
                        />
                    </div>
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="capacityBox">
                <p className="guide">{t('smart_home_panel.four_title')}</p>
                <p className="title title-bold">
                    {t('smart_home_panel.four_subtitle')}
                    <br />
                    {t('smart_home_panel.four_subtitle1')}
                </p>
                <p
                    className="desc desc-bold"
                    dangerouslySetInnerHTML={{
                        __html: t('smart_home_panel.four_des'),
                    }}
                ></p>
                <div className="capacity imgBox">
                    <EFPic name={['capacity.webp', 'capacity.jpg']} className="fullImgs" alt={t('smart_home_panel.four_title')} />
                </div>
                <p className="details details-bold">
                    {t('smart_home_panel.five_or')}
                    <span className="whiteWords"> {t('smart_home_panel.five_white_text')}</span> {t('smart_home_panel.five_gray_text')}
                </p>
                <div className="capacityBlack imgBox">
                    <EFPic name={['capacity_black.webp', 'capacity_black.jpg']} className="fullImgs" alt={t('Smart Home Panel')} />
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="output">
                <p className="guide"> {t('smart_home_panel.six_title')}</p>
                <p
                    className="title title-bold"
                    dangerouslySetInnerHTML={{
                        __html: t('smart_home_panel.six_subtitle'),
                    }}
                ></p>
                <p className="desc desc-bold">
                    {t('smart_home_panel.six_des_white')}
                    <span className="grayWords">{t('smart_home_panel.six_des_gray')}</span>
                </p>
                <p className="sup font-family-medium">{t('smart_home_panel.six_text')}</p>
                <div className="outputImg imgBox">
                    <EFPic name={['output.webp', 'output.jpg']} className="fullImgs" alt={t('Up to 7200W Output')} />
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="charging">
                <p className="guide">{t('smart_home_panel.seven_title')}</p>
                <p className="title title-bold">
                    {t('smart_home_panel.seven_subtitle')}
                    <br />
                    {t('smart_home_panel.seven_subtitle_white')} <span className="orangeWords">{t('smart_home_panel.seven_subtitle_other')}</span>
                </p>
                <p className="desc desc-bold">
                    {t('smart_home_panel.seven_des_white')}
                    <span className="grayWords">{t('smart_home_panel.seven_des_gray')}</span>
                </p>
            </div>
            <div className="chargingImg imgBox">
                <EFVideo sources={['/video/smarthomepanel/HomePanelSolar.webm', '/video/smarthomepanel/HomePanelSolar.mp4']} width="100%" />
            </div>
            <div className="switchOver">
                <p className="guide">{t('smart_home_panel.eight_title')}</p>
                <p className="title title-bold">
                    <span className="blueWords">{t('smart_home_panel.eight_subtitle_other')}</span>
                    <br />
                    {t('smart_home_panel.eight_subtitle_white')}
                </p>
                <p className="desc desc-bold">
                    {t('smart_home_panel.eight_des_white')}
                    <span
                        className="grayWords"
                        dangerouslySetInnerHTML={{
                            __html: t('smart_home_panel.eight_des_gray'),
                        }}
                    ></span>
                    {t('smart_home_panel.eight_des2_white')}
                    <span className="grayWords"> {t('smart_home_panel.eight_des2_gray')}</span>
                </p>
            </div>
            <div className="switchoverImg imgBox">
                <EFVideo sources={['/video/smarthomepanel/HomePanelUninterrupt.webm', '/video/smarthomepanel/HomePanelUninterrupt.mp4']} width="100%" />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="management">
                <p className="guide">{t('smart_home_panel.ten_title')}</p>
                <p className="title title-bold">{t('smart_home_panel.ten_subtitle')}</p>
                <p className="desc desc-bold">{t('smart_home_panel.ten_des')}</p>
            </div>
            <div className="managementSwiper">
                <div className="swiperContainer">
                    <ul className="swiperBox" ref={listContainerRef} onTouchStart={touchStart} onTouchEnd={touchEnd}>
                        {items.map((item: any, k: number) => (
                            <li className="list" key={k}>
                                <div className="swiperImg imgBox">
                                    <EFPic name={item.img} className="fullImgs" alt={t('Smart Energy Management')} />
                                </div>
                                <p className="text text-bold">{item.text}</p>
                            </li>
                        ))}
                    </ul>
                    <div className="pagination" style={{ display: swiperData.length > 1 ? '' : 'none' }}>
                        {swiperData.map((_list: any, k: number) => (
                            <li className={`paginationDot ${k === activeKey.key ? 'activeDot' : ''}`} key={k}></li>
                        ))}
                    </div>
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="store">
                <p className="guide">{t('smart_home_panel.eleven_title')}</p>
                <p
                    className="title title-bold"
                    dangerouslySetInnerHTML={{
                        __html: t('smart_home_panel.eleven_subtitle'),
                    }}
                ></p>
                <p className="desc desc-bold">
                    {t('smart_home_panel.eleven_des_white')} <br />
                    <span className="grayWords">{t('smart_home_panel.eleven_des_gray')}</span>
                </p>
            </div>
            <div className="storeImg imgBox">
                <EFPic name={[`store_${imgLocalPhone}.webp`, `store_${imgLocalPhone}.jpg`]} className="fullImgs" alt={t('Store Power for Peak Hours')} />
            </div>
            <LineSpace height={1.16} background="transparent" />
            <div className="safety">
                <p className="guide">{t('smart_home_panel.twelve_title')} </p>
                <p className="title title-bold">{t('smart_home_panel.twelve_subtitle')}</p>
                <p className="desc desc-bold">
                    {t('smart_home_panel.twelve_des_white')}
                    <span className="grayWords">&nbsp; {t('smart_home_panel.twelve_des_gray')}</span>
                </p>
            </div>
            <div className="safetyImg imgBox">
                <EFPic name={['safety.webp', 'safety.png']} className="fullImgs" alt={t('Safety features and alerts')} />
                <div className="textBox">
                    <div className="lock">
                        <p className="desc desc-bold">{t('smart_home_panel.twelve_feature')}</p>
                        <p className="line"></p>
                    </div>
                    <div className="lights">
                        <p className="desc desc-bold">{t('smart_home_panel.twelve_feature1')}</p>
                        <p className="line"></p>
                    </div>
                    <div className="pause">
                        <p className="desc desc-bold">{t('smart_home_panel.twelve_feature2')}</p>
                        <p className="line"></p>
                    </div>
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="design">
                <p className="guide"> {t('smart_home_panel.thirteen_title')}</p>
                <p className="title title-bold">{t('smart_home_panel.thirteen_subtitle')}</p>
            </div>
            <div className="designImg imgBox">
                <EFPic
                    name={[`design_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `design_${locale === 'sa' ? 'uk' : imgSpec}.png`]}
                    className="fullImgs"
                    alt={t('Modular Design')}
                />
            </div>
            <div className="designTextImg imgBox">
                <EFPic name={['design_text_img.webp', 'design_text_img.png']} className="fullImgs" alt={t('Modular Design')} />
                <div className="text text-bold">{t('smart_home_panel.thirteen_des')}</div>
            </div>
            <div className="morePower">
                <p className="title title-bold">{t('smart_home_panel.fourteen_title')}</p>
                <p className="text">{t('smart_home_panel.fourteen_subtitle')}</p>
                <p className="desc font-family-medium">{t('smart_home_panel.fourteen_des')}</p>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <OtherList theme="black" data={otherProduct} />
            <YouTubeVideoPlayer floatVideo={floatVideo} setFloatVideo={setFloatVideo} videoSrc="https://www.youtube.com/embed/kvIoQUG5Uvg" />
        </div>
    );
}
